// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Popup_wrapper__1-PcQ","icon":"Popup_icon__1loGe"};